export default __webpack_public_path__ + "4f6ce5339ad3d0ca29b45173bbbe2381.glb";